// Shared state for the /<section>/<id>/<mode> and /<section>/create pages
export default {
    data() {
        return {
            valid: true,
            saving: false,
            loadingEntity: false,
            required: [
                v => (v !== null && v !== undefined && v !== '') || 'This field is required'
            ]
        }
    },
    computed: {
        mode() {
            return this.$route.params.mode
        },
        isShow() {
            return this.mode === 'show'
        },
        isEdit() {
            return this.mode === 'edit'
        },
        isCreate() {
            return this.mode === 'create'
        },
        readOnly() {
            return this.isShow
        },
        listPath() {
            const section = '/' + this.$route.path.split('/')[1]
            return { path: section, query: this.$route.query.page ? { page: this.$route.query.page } : {} }
        },
        pageTitle() {
            if (this.isCreate) {
                return `New ${this.entityLabel.toLowerCase()}`
            }
            return this.isEdit ? `Edit ${this.entityLabel.toLowerCase()}` : this.entityLabel
        }
    },
    methods: {
        goBack() {
            this.$router.push(this.listPath)
        },
        goEdit() {
            this.$router.push({ path: this.$route.path.replace(/\/show$/, '/edit'), query: this.$route.query })
        },
        goToEntity(id, mode = 'edit') {
            this.$router.replace({ path: `${this.listPath.path}/${id}/${mode}`, query: this.$route.query })
        },
        validate() {
            return !this.$refs.form || this.$refs.form.validate()
        }
    }
}
